import { set } from 'lodash/fp';
import createReducer from '../../../../../helpers/createReducer';
import {
  fetchSmtpAccounts,
  createSmtpAccount,
  updateSmtpAccount
} from '../../../sagas/routines';

const initialState = {
  all: [],
  fetching: false,
  fetched: false,
  fetchingError: null,
  saving: false,
  saved: false,
  savingError: null
};

export const fetchSmtpAccountsHandler = routine => ({
  [routine.TRIGGER]: state => ({
    ...state,
    fetching: true,
    fetched: false
  }),
  [routine.SUCCESS]: (state, { payload: { response } }) =>
    set('all', response.items, state),
  [routine.FAILURE]: (state, { error }) => set('fetchingError', error, state),
  [routine.FULFILL]: state => ({
    ...state,
    fetching: false,
    fetched: true
  })
});

export const createOrUpdateSmtpAccountHandler = routine => ({
  [routine.TRIGGER]: state => ({
    ...state,
    saving: true,
    saved: false
  }),
  [routine.SUCCESS]: (state, { payload: { response } }) => ({
    ...state,
    all: [...state.all, response]
  }),
  [routine.FAILURE]: (state, { error, payload }) =>
    set('savingError', error || payload, state),
  [routine.FULFILL]: state => ({
    ...state,
    saving: false,
    saved: true
  })
});

export default createReducer(initialState, {
  ...fetchSmtpAccountsHandler(fetchSmtpAccounts),
  ...createOrUpdateSmtpAccountHandler(createSmtpAccount),
  ...createOrUpdateSmtpAccountHandler(updateSmtpAccount)
});
